import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static get targets () {
		return ['header', 'body'];
	}

	connect() {
		// Sentinel right above the sticky header: when it scrolls out of the
		// viewport the header is stuck, so the banner gap can be collapsed.
		this.sentinel = document.createElement('div');
		this.sentinel.setAttribute('aria-hidden', 'true');
		this.headerTarget.before(this.sentinel);

		this.observer = new IntersectionObserver(([entry]) => {
			this.headerTarget.classList.toggle('is-stuck', !entry.isIntersecting);
		});
		this.observer.observe(this.sentinel);

		this.updateColWidth = this.updateColWidth.bind(this);
		this.updateColWidth();
		this.resizeObserver = new ResizeObserver(this.updateColWidth);
		this.resizeObserver.observe(this.element);
	}

	disconnect() {
		this.observer.disconnect();
		this.sentinel.remove();
		this.resizeObserver?.disconnect();
	}

	updateColWidth() {
		const styles = getComputedStyle(this.element);
		const label = parseFloat(styles.getPropertyValue('--cpm-label')) || 160;
		const visible = parseFloat(styles.getPropertyValue('--cpm-visible')) || 2.2;
		const width = this.element.clientWidth;

		if (width <= 0 || visible <= 0) {
			return;
		}

		this.element.style.setProperty('--cpm-col', `${(width - label) / visible}px`);
	}

	sync() {
		this.headerTarget.scrollLeft = this.bodyTarget.scrollLeft;
	}
}
